import {
  makeThemedStyles,
  themedElement,
} from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
import TreeItem from "@material-ui/lab/TreeItem";
import { ICardElementWithChildren } from "backend/model/model";
import ElementIcon from "../icons/ElementIcon";
import { alpha } from "@material-ui/core/styles";
const useItemStyles = makeThemedStyles("ElementTreeViewItem", (theme) => ({
  labelContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    "& > svg": {
      color: "blue",
    },
  },
  group: {
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
  root: {
    margin: "0px",
    "& .MuiTreeItem": {
      fontSize: "30px",
    },
    "& .MuiTreeItem-iconContainer": {
      width: "0px",
      margin: "0px",
    },
    "& .MuiTreeItem-group": {
      marginInlineStart: "5px",
    },
    "& li > .MuiTreeItem-content > .MuiTreeItem-label": {
      display: "flex",
      alignItems: "center",
      padding: "2px",
      color: "#555",
      background: "transparent !important",
      pointerEvents: "none",
      borderLeft: "2px solid #ccc",
      paddingInlineStart: "10px",
      marginTop: "0px",
      fontWeight: "normal",
    },
    "& li.Mui-selected > .MuiTreeItem-content > .MuiTreeItem-label": {
      borderLeft: "2px solid #59B9F3",
      color: "#296Ba2",
    },
    "& .MuiTreeItem-content > .MuiTreeItem-label": {
      marginTop: "10px",
      fontSize: "13px",
      fontWeight: "bold",
      color: "#296Ba2",
    },
  },
  iconContainer: {
    marginRight: "12px",
    "& > svg": {
      padding: "8px",
      "&:hover": {
        opacity: 0.6,
      },
    },
  },
  label: {
    padding: 0,
  },
  selected: {
    "& > .MuiTreeItem-content  > .MuiTreeItem-label::before": {
      background: theme.palette.primary.main,
      border: "1px solid transparent",
    },
  },
}));

const ElementTreeViewItem = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
  }>
) => {
  const { item } = props;
  const styles = useItemStyles();
  return (
    <TreeItem
      nodeId={item.id}
      label={
        <div className={styles.labelContainer}>
          <div>{item.name}</div>
        </div>
      }
      classes={{
        root: styles.root,
        selected: styles.selected,
        iconContainer: styles.iconContainer,
        label: styles.iconContainer,
      }}
    >
      {item.children
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((child) => (
          <ElementTreeViewItem key={child.id} item={child} />
        ))}
    </TreeItem>
  );
};

export default ElementTreeViewItem;
